import appsClinician from './dashboard'

export default [...appsClinician]